import { LanguageDirection } from '../../entities';
import { getLanguageDirection } from '../../utils/getLanguageDirection';
import { getLocalization } from '../../utils/getLocalization';

export class LocalizationService {
  private get locale() {
    return getLocalization();
  }

  get isRtl() {
    return getLanguageDirection(this.locale) === LanguageDirection.RTL;
  }
}
